//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import userbar from './common/userbar'
import mobile_menu from './common/moible.menu'
import header_menu from './common/header.menu'

export default {
  name: 'appheader',
  components: {
    mobile_menu,
    userbar,
    header_menu
  },
  created() {
    window._header = this;
    window.addEventListener('scroll', this.scrollToTop)
    this.$nextTick(() => {
      if (this.$refs.header) {
        this.header_height = this.$refs.header.offsetHeight
      }
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  data() {
    return {
      header_height: 0,
      btnFlag: false
    }
  }, methods: {
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    scrollToTop() {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 0) {
        this.btnFlag = true
      } else {
        this.btnFlag = false
      }
    }
  }
}
